var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:`button-list ${_vm.classes}`},_vm._l((_vm.items),function(button,index){return _c('DefaultButton',{key:index,attrs:{"label":button.label,"labelClass":"text-uppercase","buttonClass":"button-large","type":"popup"},on:{"pressed":function($event){return _vm.onPressed(button)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }